var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_146952",
    "data-name": "Group 146952",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.776,
    height: 23.055,
    viewBox: "0 0 22.776 23.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_50312",
    "data-name": "Path 50312",
    d: "M.942,11.392v11.9L8.56,17.341Z",
    transform: "translate(-0.942 -1.333)",
    fill: "#80838e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50313",
    "data-name": "Path 50313",
    d: "M23.449,7.887v3.658L25.7,9.788Z",
    transform: "translate(-3.575 -0.923)",
    fill: "#80838e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50314",
    "data-name": "Path 50314",
    d: "M13.978.158a.668.668,0,0,0-.863,0l-1.776,1.5h4.415Z",
    transform: "translate(-2.159 0)",
    fill: "#80838e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50315",
    "data-name": "Path 50315",
    d: "M3.931,7.887l-2.25,1.9,2.25,1.757Z",
    transform: "translate(-1.029 -0.923)",
    fill: "#80838e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50316",
    "data-name": "Path 50316",
    d: "M9.926,19,1.887,25.278H22.864L14.826,19Z",
    transform: "translate(-1.053 -2.223)",
    fill: "#80838e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50317",
    "data-name": "Path 50317",
    d: "M18.109,17.341l7.618,5.949v-11.9Z",
    transform: "translate(-2.951 -1.333)",
    fill: "#80838e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50318",
    "data-name": "Path 50318",
    d: "M13.5,9.108A1.27,1.27,0,0,0,12.4,10.526c0,.9.548,1.509,1.06,1.509.539,0,.981-.633,1.013-1.43v-.169c-.024-.786-.416-1.328-.969-1.328Z",
    transform: "translate(-2.282 -1.066)",
    fill: "#80838e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50319",
    "data-name": "Path 50319",
    d: "M15.342,15.733l4.7-3.667V4.075a.671.671,0,0,0-.67-.673H6.417a.671.671,0,0,0-.67.673v7.991l4.7,3.667ZM8.17,11.156a4.951,4.951,0,0,1,3.26-5.95A4.909,4.909,0,0,1,17.624,8.48l.006.021a4.444,4.444,0,0,1-.245,2.932,2.266,2.266,0,0,1-2.1,1.5A1.53,1.53,0,0,1,14.2,12.46,1.72,1.72,0,0,1,14,12.229a2.08,2.08,0,0,1-1.326.484,2.251,2.251,0,0,1-1.727-.866,3.135,3.135,0,0,1-.673-1.988,2.922,2.922,0,0,1,.716-1.967,2.344,2.344,0,0,1,1.729-.8,2.112,2.112,0,0,1,.992.244.67.67,0,0,1,.658-.547h0a.671.671,0,0,1,.667.676l-.018,3.737a.439.439,0,0,0,.121.306.216.216,0,0,0,.139.071.941.941,0,0,0,.855-.648,3.143,3.143,0,0,0,.2-2.077,3.573,3.573,0,0,0-6.873,1.955,3.6,3.6,0,0,0,3.357,2.678.673.673,0,0,1-.018,1.345h-.019A4.918,4.918,0,0,1,8.17,11.156Z",
    transform: "translate(-1.504 -0.398)",
    fill: "#80838e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.900f9402f1d4e9a7d7135f1bda468ed0.svg";
export { ForwardRef as ReactComponent };